module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/babel-loader/lib/index.js??ref--9-0!./brace.bundle.js"));
	}, "brace.bundle");
}